import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MailUnsubscribeComponent } from './components/mail-unsubscribe/mail-unsubscribe.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
  { path: 'painel', canActivate: [AuthGuard], loadChildren: () => import('./modules/painel/painel.module').then(m => m.PainelModule) },
  { path: 'mail-unsubscribe', component: MailUnsubscribeComponent },
  { path: '**', redirectTo: 'auth' },
  { path: 'home-cliente', loadChildren: () => import('./modules/painel/modules-cliente/home-cliente/home-cliente.module').then(m => m.HomeClienteModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
